import React, { useEffect, useRef, useState } from 'react'
import { AMBKingConfig } from '../../entities/AMBKing'
import ProviderList from './AMBKing1/ProviderList'
import GameList from './AMBKing1/GameList'
import ShowGame from './AMBKing1/ShowGame'
import { Button, Empty, Skeleton } from 'antd'
import { CategoryGameAMBKing1 } from '../../utils/categoryGame'
import { useSelector } from 'react-redux'
import { ApplicationState } from '../../store'
import { useLocation, useHistory } from 'react-router-dom';
import MainSlider from '../Wallet/MainSlider'
import Footer from '../Layout/Footer'
import SeoContent from '../Layout/SeoContent'
import LoadingLayout from '../Layout/LoadingLayout'
import { makePath } from '../../helpers/path'
import Popup from '../Popup'
import CheckInModal from '../CheckIn/CheckInModal'
import WalletPromotionContainer from '../Home/WalletPromotionContainer'
import JackpotWidget from '../Home/JackpotWidget'
import OnlineWidget from '../Home/OnlineWidget'

const AMBKing = () => {
    const location = useLocation();
    const history = useHistory();

    const [config, setConfig] = useState<AMBKingConfig | undefined>(undefined)
    const [provider, setProvider] = useState('')
    const [pathName, setPathName] = useState<string>('')
    const [gameType, setGameType] = useState<string>('slot')
    const [loading, setLoading] = useState<boolean>(false)
    const [loadingProvider, setLoadingProvider] = useState<boolean>(false)
    const [loadingAMBKing, setLoadingAMBKing] = useState<boolean>(false)
    const [allProvider, setAllProvider] = useState<any>(undefined)

    const tabsRef = useRef<(HTMLDivElement | null)[]>([])
    const tabListRef = useRef<HTMLDivElement | null>(null)
    const [distanceFromMenuToTab, setDistanceFromMenuToTab] = useState<number>(0)
    const [widthToTab, setWidthToTab] = useState<number>(0)

    const [isSticky, setIsSticky] = useState<boolean>(false)

    const providerState = useSelector((state: ApplicationState) => state.provider)
    const providerHomeState = useSelector((state: ApplicationState) => state.gamesHome)
    const prefixState = useSelector((state: ApplicationState) => state.prefix)
    const userState = useSelector((state: ApplicationState) => state.user)

    // 🔹 ข้อมูล prefix 
    const prefixData = [
        { prefix: 'CB988', jackpot: 516_196, online: 8_231, online2: 8_000 },
        { prefix: 'OD911', jackpot: 716_196, online: 9_491, online2: 9_000 },
        { prefix: 'WK89', jackpot: 716_196, online: 9_491, online2: 9_000 },
        { prefix: 'K88', jackpot: 716_196, online: 9_491, online2: 9_000 },
        { prefix: 'LK789', jackpot: 416_196, online: 5_294, online2: 5_000 },
        { prefix: 'TH44', jackpot: 616_196, online: 6_491, online2: 6_000 },
        { prefix: 'AT77', jackpot: 616_196, online: 6_491, online2: 6_000 },
        { prefix: '1XHENG', jackpot: 586_196, online: 5_146, online2: 5_000 },
        { prefix: 'HRM888', jackpot: 886_196, online: 12_146, online2: 10_000 },
    ] as const;

    // 🔹 prefix ที่ต้องการให้แสดง (จะใช้ทั้งหมดก็ได้)
    const prefixShow = prefixData.map((p) => p.prefix);

    // 🔹 state ตัวอย่าง (มาจาก context/redux/form แล้วแต่โครงสร้างจริง)
    const { prefix } = prefixState.info ?? {};

    // 🔹 หา record ที่ตรงกับ prefix ปัจจุบัน
    const current = prefixData.find((p) => p.prefix === prefix);

    useEffect(() => {
        if (providerState?.info !== undefined && location.pathname === '/launch-game') {
            setConfig(providerState?.info)
            setAllProvider(providerState?.info?.games)
            if (Object.values(providerState?.info?.games).length === 1) {
                setGameType(Object.keys(providerState?.info?.games)[0]);
            }

            setLoadingAMBKing(true)
        }

        if (providerHomeState?.info !== undefined && location.pathname === '/home') {
            setConfig(providerHomeState?.info)
            setAllProvider(providerHomeState?.info?.games)
            if (Object.values(providerHomeState?.info?.games).length === 1) {
                setGameType(Object.keys(providerHomeState?.info?.games)[0]);
            }

            setLoadingAMBKing(true)
        }

        setPathName(location.pathname === '/launch-game' ? 'launch-game' : 'home')

    }, [providerState?.info, providerHomeState?.info, location]) // eslint-disable-line

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const gameTypeQuery = params.get('gameType');
        const providerQuery = params.get('provider');

        const getIsGamePromotion = localStorage.getItem('isGamePromotion')
        if (getIsGamePromotion && getIsGamePromotion === 'on') {
            document.getElementById(gameType)?.click()
        }

        if (gameTypeQuery) {
            setGameType(gameTypeQuery);
            params.set('gameType', gameTypeQuery);
            history.push({ search: params.toString() });
        } else {
            for (const gameType of Object.values(CategoryGameAMBKing1)) {
                if (Object(allProvider)[(gameType.key).toLowerCase()] !== undefined) {
                    setGameType(gameType.key);
                    params.set('gameType', gameType.key);
                    history.push({ search: params.toString() });
                    break;
                }
            }
        }

        if (providerQuery) {
            if (getIsGamePromotion && getIsGamePromotion === 'on') {
                setProvider('');
            } else {
                setProvider(providerQuery);
            }
        }

        if (gameTypeQuery === 'favorite' && location.pathname === '/home') {
            params.set('gameType', 'slot');
            history.push({ search: params.toString() });
        }
    }, [allProvider, CategoryGameAMBKing1, location.search]) //eslint-disable-line

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const gameTypeQuery = params.get('gameType');
        const providerQuery = params.get('provider');
        const filterQuery = params.get('filter');

        const getIsGamePromotion = localStorage.getItem('isGamePromotion')
        if (getIsGamePromotion && getIsGamePromotion === 'on') {
            document.getElementById(gameType)?.click()
        }

        if (gameTypeQuery) {
            setGameType(gameTypeQuery);
            params.set('gameType', gameTypeQuery);
            params.set('filter', filterQuery ? filterQuery : 'off');
            history.push({ search: params.toString() });
        } else {
            for (const gameType of Object.values(CategoryGameAMBKing1)) {
                if (Object(allProvider)[(gameType.key).toLowerCase()] !== undefined) {
                    setGameType(gameType.key);
                    params.set('gameType', gameType.key);
                    params.set('filter', filterQuery ? filterQuery : 'off');
                    history.push({ search: params.toString() });
                    break;
                }
            }
        }

        if (providerQuery) {
            if (getIsGamePromotion && getIsGamePromotion === 'on') {
                setProvider('');
            } else {
                setProvider(providerQuery);
            }
        }

        if (gameTypeQuery === 'favorite' && location.pathname === '/home') {
            params.set('gameType', 'slot');
            history.push({ search: params.toString() });
        }
    }, [allProvider, CategoryGameAMBKing1, location.search]) //eslint-disable-line


    useEffect(() => {
        if (!provider) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [provider])

    // set provider to url
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        provider?.length ? params.set('provider', provider) : params.delete('provider');
        history.push({ search: params.toString() });
    }, [history, location.search, provider]);

    // get query string
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const gameTypeQuery = params.get('gameType');
        const providerQuery = params.get('provider');

        if (gameTypeQuery) {
            setGameType(gameTypeQuery);
        }

        if (providerQuery) {
            setProvider(providerQuery);
        }
        setLoading(false)
    }, [location.search]);

    if (!config) {
        return (
            <div>
                <div className="ambbet-topbar-skeleton">
                    <div className="amb-button-skeleton">
                        {
                            Array.from({ length: 10 }, (_, index) => (
                                <Skeleton.Button key={index} active />
                            ))
                        }
                    </div>
                </div>

                <div className="ambbet-provider-skeleton">
                    {
                        Array.from({ length: 24 }, (_, index) => (
                            <Skeleton.Button key={index} active />
                        ))
                    }
                </div>
            </div>
        )
    }

    const handleGameType = (game: string) => {
        const params = new URLSearchParams(location.search);

        window.scrollTo({ top: 0, behavior: 'smooth' });
        setProvider('')
        setGameType(game)
        params.set('gameType', game);
        params.delete('gameFilter');
        params.delete('provider');
        history.push({ search: params.toString() });
    }

    const TabGameType: any = loadingAMBKing && CategoryGameAMBKing1.filter((item) => {
        if (Object(allProvider)[(item.key).toLowerCase()] === undefined) {
            return false;
        }
        return true;
    }).map((x) => {
        return (
            <div
                id={x.key}
                className={`launch-game-tab launch-game-tabs-menu-ambking launch-game-tab-${x.key} ${x.key === gameType ? `launch-game-tab-active` : ''} launch-game-tab-ambking`}
                key={`menu-tab-${x.key}`}
                onClick={() => { handleGameType(x.key) }}
            >
                <img src={`/icons/game-type/${x.key}.png`} alt={x.title} />
                <span>{x.title === 'ปลา' ? 'ยิงปลา' : x.title}</span>
            </div>
        )
    })

    return (
        <div className='launch-game-container'>
            <MainSlider prefixState={prefixState} />
            {current && prefixShow.includes(current.prefix) && (
                <>
                    {/* <OnlineWidget data={current.online} data2={current.online2} />
                    {!userState.info && (
                        <JackpotWidget data={current.jackpot} />
                    )} */}
                    {/* <WithdrawWidget /> */}
                </>
            )}
            {!userState.info && (
                <div className="topbar-member-betflix">
                    <Button
                        type='primary'
                        size='small'
                        style={{ display: 'block', fontSize: 14 }}
                        block
                        onClick={() => history.push(makePath('/login'))}
                    >
                        เข้าสู่ระบบ
                    </Button>
                    {(!prefixState.info?.functions.hasOwnProperty("offRegister") || !prefixState.info?.functions['offRegister']) && (
                        <Button
                            size='small'
                            style={{ marginLeft: 12, display: 'block', fontSize: 14 }}
                            block
                            onClick={() => history.push(makePath('/register'))}
                        >
                            สมัครสมาชิก
                        </Button>
                    )}
                </div>
            )}
            <div className='launch-game-tabs'>
                {allProvider && Object.keys(allProvider).length > 1 && (
                    <div ref={tabListRef} className={`launch-game-tabs-list ${isSticky ? 'launch-game-tabs-list-sticky' : ''}`}>
                        <div className='launch-game-tabs-menu' style={{ overflowX: 'auto', margin: '0 -12px' }}>
                            <div
                                id={'favorite'}
                                className={`launch-game-tab launch-game-tabs-menu-ambking launch-game-tab-favorite launch-game-tab-ambking ${gameType === 'favorite' ? `launch-game-tab-active` : ''}`}
                                key={`menu-tab-favorite`}
                                onClick={() => { location.pathname === '/launch-game' ? handleGameType('favorite') : history.push(makePath('/login')) }}
                            >
                                <img src={`/icons/3d/favorite.svg`} alt={'favorite'} />
                                <span>เกมโปรด</span>
                            </div>
                            {TabGameType}
                        </div>
                        <div className='launch-game-tabs-underline' style={{ width: widthToTab, transform: `translateX(${distanceFromMenuToTab}px)` }}></div>
                    </div>
                )}
                <div className='launch-game-tab-content' style={{ paddingTop: 0 }}>
                    {loading ? (
                        <LoadingLayout prefix={prefixState} />
                    ) : (
                        !provider ? (
                            ((gameType === 'sport') || (gameType === 'lotto') || (gameType === 'favorite' && location.pathname === '/launch-game') ? (
                                <ShowGame
                                    games={allProvider[(gameType).toLowerCase()]}
                                    provider={provider as string}
                                    setProvider={setProvider}
                                    gameType={gameType}
                                    setLoading={setLoading}
                                    pathName={pathName}
                                />
                            ) :
                                (Object(allProvider)[(gameType).toLowerCase()] !== undefined && Object(allProvider)[(gameType).toLowerCase()].length > 0 ? (
                                    <ProviderList
                                        key={`ProviderList_${gameType}_${gameType}`}
                                        config={allProvider[(gameType).toLowerCase()]}
                                        type={gameType}
                                        setProvider={setProvider}
                                        setGameType={setGameType}
                                    />
                                ) :
                                    <div style={{ display: 'flex', width: '100%', marginTop: '12px' }}>
                                        <Empty
                                            description='ไม่พบเกมส์'
                                            image="/icons/new/empty-box.svg"
                                            imageStyle={{ height: 88 }}
                                            style={{ flex: 'auto', marginTop: 24 }}
                                        />
                                    </div>
                                )
                            )
                        ) : (
                            <GameList
                                games={allProvider[gameType]}
                                provider={provider as string}
                                gameType={gameType}
                                loadingProvider={loadingProvider}
                                setProvider={setProvider}
                                setLoadingProvider={setLoadingProvider}
                                setLoading={setLoading}
                                pathName={pathName}
                            />
                        )
                    )}
                </div>
            </div>

            {/* Promotion */}
            {(prefixState.info?.promotions.length || 0) > 0 && !prefixState.info?.functions.homePromotionPage && location.pathname === '/home' && (
                <WalletPromotionContainer promotions={prefixState.info?.promotions} />
            )}

            {location.pathname === '/home' && <SeoContent />}

            <Footer prefixState={prefixState} />

            {/* Popup */}
            <Popup />

            {/* CheckIn */}
            {prefixState.info?.checkin.enable && <CheckInModal />}

        </div>
    )
}

export default AMBKing
